import { getAlternativeFromAddress, getDefaultFromAddress } from './getFromAddresses';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
export default function createFromRecipientWell(fromAddress, referenceItemId) {
    if (fromAddress) {
        return {
            email: fromAddress,
        };
    }
    else {
        var userConfig = getUserConfiguration();
        var address = isConsumer()
            ? userConfig.SessionSettings.DefaultFromAddress
            : userConfig.UserOptions.SendAddressDefault;
        if (!address) {
            address = userConfig.SessionSettings.UserEmailAddress;
        }
        var defaultFromAddress = getDefaultFromAddress(referenceItemId);
        address = defaultFromAddress ? defaultFromAddress : getAlternativeFromAddress(address);
        return {
            email: {
                MailboxType: 'Mailbox',
                RoutingType: 'SMTP',
                EmailAddress: address,
                Name: userConfig.SessionSettings.UserDisplayName,
            },
        };
    }
}
//# sourceMappingURL=createFromRecipientWell.js.map